import {
  useCompositeStoreOptions,
  useCompositeStoreProps
} from "../__chunks/7KULBIZY.js";
import "../__chunks/RS7KBRGA.js";
import {
  usePopoverStoreOptions,
  usePopoverStoreProps
} from "../__chunks/3PKTK2K7.js";
import "../__chunks/WC3GK4CL.js";
import "../__chunks/SWJ5EOOS.js";
import {
  useStore,
  useStoreProps
} from "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/combobox/combobox-store.ts
import * as Core from "@ariakit/core/combobox/combobox-store";
function useComboboxStoreOptions(props) {
  return __spreadValues(__spreadValues({}, useCompositeStoreOptions(props)), usePopoverStoreOptions(props));
}
function useComboboxStoreProps(store, props) {
  store = useCompositeStoreProps(store, props);
  store = usePopoverStoreProps(store, props);
  useStoreProps(store, props, "value", "setValue");
  return store;
}
function useComboboxStore(props = {}) {
  const options = useComboboxStoreOptions(props);
  const store = useStore(
    () => Core.createComboboxStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useComboboxStoreProps(store, props);
}
export {
  useComboboxStore,
  useComboboxStoreOptions,
  useComboboxStoreProps
};
